import * as Sentry from '@sentry/react';
import { setRuntimeContext } from 'sentry/contexts/runtimeContext';
import { Task } from '../../gql/graphql';

export function updateModalContextInSentry(key: string | undefined, additionalInfo?: {
  step?: number;
  task?: Task;
}): void {
  if (key) {
    // Modal is opening
    Sentry.addBreadcrumb({ 
      category: 'ui.modal', 
      message: `open ${key}`, 
      level: 'info' 
    });
    Sentry.setTag('modalOpen', key);
    
    const modalContext: any = { 
      key, 
      open: true 
    };
    
    // Add additional info if provided
    if (additionalInfo) {
      if (additionalInfo.step !== undefined) modalContext.step = additionalInfo.step;
      if (additionalInfo.task) modalContext.task = additionalInfo.task;
    }
    
    Sentry.setContext('modal', modalContext);
    setRuntimeContext({ modal: modalContext });
  } else {
    // Modal is closing
    Sentry.addBreadcrumb({ 
      category: 'ui.modal', 
      message: 'close modal', 
      level: 'info' 
    });
    Sentry.setTag('modalOpen', 'none');
    Sentry.setContext('modal', { key: null, open: false });
    setRuntimeContext({ modal: { key: null, open: false } });
  }
}

